interface IFragFinderHeadingProps {
    className?: string
    text: string
    onClick?: () => void
}

export const FragFinderHeading = (props: IFragFinderHeadingProps) => {
    return (
        <div className={`${props.className} text-center font-joan bg-gradient-to-r from-[#6478D1] to-[#291A85] bg-clip-text text-transparent`}
            onClick={props.onClick}
        >
            {props.text}
        </div>
    )
}